import { Icon, IconProps } from './Icon';

export type RemoveProps = IconProps;

export const Remove = (props: RemoveProps) => (
  <Icon width="16px" height="16px" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <path d="m11.333 6-4 4m0-4 4 4m-9.52-1.36 2.88 3.84c.235.313.352.47.501.582.132.1.28.175.44.22.18.051.375.051.766.051h5.067c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874c.218-.428.218-.988.218-2.108V5.867c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874c-.428-.218-.988-.218-2.108-.218H6.4c-.391 0-.587 0-.766.05-.16.046-.308.12-.44.22-.149.114-.266.27-.5.583l-2.88 3.84c-.173.23-.259.344-.292.47a.667.667 0 0 0 0 .34c.033.126.12.24.291.47Z" stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round"/>
  </Icon>
)
